import { initVue } from '../utils/vue';

import layout from '../layouts/Default';
import page from '../pages/Timeline';

initVue({ layout, page });
